export default "__VITE_ASSET__CBEW22D0__"